export default "__VITE_ASSET__Ce1js423__"